import { type ReactElement, type PropsWithChildren } from 'react';

import { Counter } from '@beeline/design-system-react/extracted-styles';

import styles from './styles.module.scss';

export const WithCounter = ({
  children,
  count,
}: PropsWithChildren<{ count?: number }>): ReactElement => {
  if (!count) {
    return <>{children}</>;
  }

  return (
    <Counter count={count} size='medium' className={styles.counter}>
      {children}
    </Counter>
  );
};
